import { motion } from 'framer-motion';
import OptimizedImage from './OptimizedImage';
import '../styles/TrustIndicators.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

const AIIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="aiGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="60" fill="url(#aiGrad)" opacity="0.3" />
    <circle cx="100" cy="100" r="45" fill="none" stroke="white" strokeWidth="2" opacity="0.6" />
    <circle cx="70" cy="80" r="8" fill="white" />
    <circle cx="130" cy="80" r="8" fill="white" />
    <circle cx="100" cy="130" r="8" fill="white" />
    <line x1="100" y1="100" x2="70" y2="80" stroke="white" strokeWidth="1.5" opacity="0.8" />
    <line x1="100" y1="100" x2="130" y2="80" stroke="white" strokeWidth="1.5" opacity="0.8" />
    <line x1="100" y1="100" x2="100" y2="130" stroke="white" strokeWidth="1.5" opacity="0.8" />
  </svg>
);

const CloudIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="cloudGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M 60 110 Q 50 110 50 100 Q 50 85 65 85 Q 70 70 85 70 Q 100 70 105 85 Q 120 85 125 100 Q 125 110 115 110 Z" fill="url(#cloudGrad)" opacity="0.4" />
    <path d="M 55 115 Q 45 115 45 105 Q 45 88 60 88 Q 65 72 80 72 Q 95 72 100 88 Q 115 88 120 105 Q 120 115 110 115 Z" fill="none" stroke="white" strokeWidth="2.5" />
    <circle cx="85" cy="135" r="4" fill="white" opacity="0.7" />
    <circle cx="105" cy="140" r="3" fill="white" opacity="0.7" />
  </svg>
);

const TransformationIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="transformGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <rect x="50" y="60" width="25" height="70" fill="none" stroke="white" strokeWidth="2.5" opacity="0.6" />
    <rect x="85" y="50" width="25" height="80" fill="url(#transformGrad)" opacity="0.3" />
    <rect x="85" y="50" width="25" height="80" fill="none" stroke="white" strokeWidth="2.5" />
    <rect x="120" y="35" width="25" height="95" fill="none" stroke="white" strokeWidth="2.5" opacity="0.7" />
    <circle cx="62.5" cy="55" r="3" fill="white" />
    <circle cx="97.5" cy="45" r="3" fill="white" />
    <circle cx="132.5" cy="30" r="3" fill="white" />
  </svg>
);

const AgileIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="agileGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g opacity="0.4" fill="url(#agileGrad)">
      <circle cx="70" cy="85" r="12" />
      <circle cx="100" cy="70" r="12" />
      <circle cx="130" cy="85" r="12" />
      <circle cx="130" cy="115" r="12" />
      <circle cx="100" cy="130" r="12" />
      <circle cx="70" cy="115" r="12" />
    </g>
    <g fill="none" stroke="white" strokeWidth="2">
      <circle cx="70" cy="85" r="12" />
      <circle cx="100" cy="70" r="12" />
      <circle cx="130" cy="85" r="12" />
      <circle cx="130" cy="115" r="12" />
      <circle cx="100" cy="130" r="12" />
      <circle cx="70" cy="115" r="12" />
      <line x1="70" y1="85" x2="100" y2="70" strokeWidth="1.5" opacity="0.8" />
      <line x1="100" y1="70" x2="130" y2="85" strokeWidth="1.5" opacity="0.8" />
      <line x1="130" y1="85" x2="130" y2="115" strokeWidth="1.5" opacity="0.8" />
      <line x1="130" y1="115" x2="100" y2="130" strokeWidth="1.5" opacity="0.8" />
      <line x1="100" y1="130" x2="70" y2="115" strokeWidth="1.5" opacity="0.8" />
      <line x1="70" y1="115" x2="70" y2="85" strokeWidth="1.5" opacity="0.8" />
    </g>
  </svg>
);

const ConsultingIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="consultGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g opacity="0.3" fill="url(#consultGrad)">
      <path d="M 100 60 L 130 90 L 100 120 L 70 90 Z" />
    </g>
    <g fill="none" stroke="white" strokeWidth="2">
      <path d="M 100 60 L 130 90 L 100 120 L 70 90 Z" />
      <line x1="100" y1="60" x2="100" y2="120" />
      <line x1="70" y1="90" x2="130" y2="90" />
      <circle cx="100" cy="90" r="4" fill="white" />
    </g>
    <circle cx="100" cy="145" r="15" fill="none" stroke="white" strokeWidth="2" opacity="0.7" />
    <circle cx="80" cy="160" r="12" fill="none" stroke="white" strokeWidth="1.5" opacity="0.6" />
    <circle cx="120" cy="160" r="12" fill="none" stroke="white" strokeWidth="1.5" opacity="0.6" />
  </svg>
);

const AutomationIllustration = () => (
  <svg viewBox="0 0 200 200" className="trust-indicators__illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="automationGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e0f0ff', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <g opacity="0.4" fill="url(#automationGrad)">
      <rect x="50" y="65" width="20" height="25" rx="2" />
      <rect x="90" y="65" width="20" height="25" rx="2" />
      <rect x="130" y="65" width="20" height="25" rx="2" />
    </g>
    <g fill="none" stroke="white" strokeWidth="2.5">
      <rect x="50" y="65" width="20" height="25" rx="2" />
      <rect x="90" y="65" width="20" height="25" rx="2" />
      <rect x="130" y="65" width="20" height="25" rx="2" />
    </g>
    <g stroke="white" strokeWidth="1.5" fill="none" opacity="0.8">
      <path d="M 70 95 L 85 110" />
      <path d="M 110 95 L 125 110" />
      <path d="M 60 125 L 100 130 L 140 125" />
    </g>
    <circle cx="100" cy="150" r="8" fill="none" stroke="white" strokeWidth="2" opacity="0.6" />
  </svg>
);

const GridPattern = () => (
  <svg className="trust-indicators__pattern" viewBox="0 0 100 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="gridPattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
        <circle cx="10" cy="10" r="2" fill="rgba(255,255,255,0.08)" />
      </pattern>
    </defs>
    <rect width="100" height="100" fill="url(#gridPattern)" />
  </svg>
);

const highlights = [
  {
    title: 'AI & Data Engineering Expertise',
    image: '/highlight-images/ai-data-engineering.png',
    gradient: 'linear-gradient(135deg, #1f6fa8, #2ea8ff)',
    bgGradient: 'linear-gradient(135deg, rgba(31, 111, 168, 0.08), rgba(46, 168, 255, 0.08))',
  },
  {
    title: 'Cloud-Native Product Development',
    image: '/highlight-images/cloud-native-product.png',
    gradient: 'linear-gradient(135deg, #0f4c75, #1f6fa8)',
    bgGradient: 'linear-gradient(135deg, rgba(15, 76, 117, 0.08), rgba(31, 111, 168, 0.08))',
  },
  {
    title: 'Enterprise Digital Transformation',
    image: '/highlight-images/enterprise-transformation.png',
    gradient: 'linear-gradient(135deg, #2ea8ff, #00d4ff)',
    bgGradient: 'linear-gradient(135deg, rgba(46, 168, 255, 0.08), rgba(0, 212, 255, 0.08))',
  },
  {
    title: 'Agile & Scalable Delivery Teams',
    image: '/highlight-images/agile-delivery.png',
    gradient: 'linear-gradient(135deg, #1f6fa8, #0f4c75)',
    bgGradient: 'linear-gradient(135deg, rgba(31, 111, 168, 0.08), rgba(15, 76, 117, 0.08))',
  },
  {
    title: 'End-to-End Technology Consulting',
    image: '/highlight-images/consulting.png',
    gradient: 'linear-gradient(135deg, #2ea8ff, #1f6fa8)',
    bgGradient: 'linear-gradient(135deg, rgba(46, 168, 255, 0.08), rgba(31, 111, 168, 0.08))',
  },
  {
    title: 'Intelligent Automation & Workflow Optimization',
    image: '/highlight-images/automation-workflow.png',
    gradient: 'linear-gradient(135deg, #2563eb, #1f6fa8)',
    bgGradient: 'linear-gradient(135deg, rgba(37, 99, 235, 0.08), rgba(31, 111, 168, 0.08))',
  },
];

export default function TrustIndicators() {
  return (
    <section className="section trust-indicators">
      <div className="container">
        <motion.div className="trust-indicators__header" {...fadeUp(0)}>
          <h2 className="section__title">
            Trusted Technology Partner for <span>Scalable Innovation</span>
          </h2>
          <p className="trust-indicators__subtitle">
            We combine engineering excellence, AI innovation, and business-first thinking to help organizations solve complex challenges and deliver measurable outcomes.
          </p>
        </motion.div>

        <div className="trust-indicators__grid">
          {highlights.map((highlight, idx) => (
            <motion.div
              key={idx}
              className="trust-indicators__card"
              {...fadeUp(0.1 + idx * 0.08)}
              whileHover={{ y: -8 }}
            >
              <div
                className="trust-indicators__card-header"
              >
                <OptimizedImage
                  src={highlight.image}
                  alt={highlight.title}
                  className="trust-indicators__card-image"
                />
              </div>
              <div
                className="trust-indicators__card-body"
                style={{ background: highlight.bgGradient }}
              >
                <div className="trust-indicators__pattern-overlay">
                  <GridPattern />
                </div>
                <h3 className="trust-indicators__card-title">{highlight.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
